export const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

export const phoneRegex =
  /^\+(\d{1,3})[- ]?\(?\d{1,4}\)?[- ]?\d{1,4}[- ]?\d{1,9}$/;
